/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function Books(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M40,80H88V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z" opacity={0.2} />
      <Path d="M88,176h48V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8Z" opacity={0.2} />
      <Path
        d="M171.24109,179.15894l46.36444-12.42331,8.28221,30.90962a8,8,0,0,1-5.65685,9.798l-30.90963,8.28221a8,8,0,0,1-9.798-5.65685Z"
        opacity={0.2}
      />
      <Path
        d="M146.39447,86.43006l46.36444-12.42331L184.4767,43.09712a8,8,0,0,0-9.798-5.65685l-30.90963,8.28221a8,8,0,0,0-5.65685,9.798Z"
        opacity={0.2}
      />
      <Rect
        x={40}
        y={40}
        width={48}
        height={176}
        rx={8}
        strokeWidth={16}
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <Line
        x1={40}
        y1={80}
        x2={88}
        y2={80}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Rect
        x={88}
        y={40}
        width={48}
        height={176}
        rx={8}
        strokeWidth={16}
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <Line
        x1={88}
        y1={176}
        x2={136}
        y2={176}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Rect
        x={158}
        y={38.58284}
        width={48}
        height={176}
        rx={8}
        transform="translate(-26.56055 51.41827) rotate(-15)"
        strokeWidth={16}
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <Line
        x1={171.24109}
        y1={179.15894}
        x2={217.60553}
        y2={166.73563}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={146.39447}
        y1={86.43006}
        x2={192.75891}
        y2={74.00675}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default Books;
